// ₱12,450.00 with thousands separators; negatives read -₱1,200.00.
export const peso = (value) =>
  `${value < 0 ? '-' : ''}₱${Math.abs(value).toLocaleString('en-PH', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

// Whole pesos for round figures such as targets: ₱625,440.
export const pesoWhole = (value) => `₱${value.toLocaleString('en-PH', { maximumFractionDigits: 0 })}`;
